import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { Breakpoints } from 'styles/variables/breakpoints';
import { Colors } from 'styles/variables/colors';

const { sm, lg, xl } = Breakpoints;
const { white } = Colors;

export const Button = styled.button`
    display: flex;
    ${TextStyle({ fontSize: '22px', fontWeight: '700' })}
    gap: 0.7rem;
    justify-content: center;
    align-items: center;
    font-style: normal;
    padding: 4px 16px;
    margin-top: 1rem;
    background: ${white};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 50px;
    @media screen and (max-width: ${xl}) {
        font-size: 20px;
    }
    @media screen and (max-width: ${lg}) {
        font-size: 18px;
    }
    @media screen and (max-width: ${sm}) {
        letter-spacing: -0.1px;
        gap: 0.5rem;
        padding: 4px 13px;
        font-size: 16px;
    }
    @media screen and (max-width: 510px) {
        letter-spacing: -0.1px;
        gap: 0.5rem;
        padding: 1px 13px;
        font-size: 16px;
        box-shadow: none;
        margin: 18px 0px;
        border-radius: 10px;
        border: 1px solid blue;
        gap: 10px;
        ${TextStyle({ fontSize: '15px', fontWeight: '400' })}
    }
`;

export const showLP = styled.div`
    display: none;
    @media screen and (max-width: 510px) {
        display: unset;
    }
`;

export const hideLP = styled.div`
    @media screen and (max-width: 510px) {
        display: none;
    }
`;
